import { Tab as MuiTab } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Tab = styled(MuiTab)({
  position: "relative",
  minWidth: "auto",
  padding: "6px 0px",
  margin: "0px 37px",
  "&:first-of-type": {
    marginLeft: "0px",
  },
  opacity: 1,
});
